import { RulesetEnum } from '../enums/RulesetEnum';
import { BuildRulesetQuery } from '../interfaces/Rulesets';
import { buildQuery_ruleset1_PD, order_ruleset1_PD, selectFields_ruleset1_PD } from '../sql/rulesets/new/ruleset1_PD';
import {
    order_ruleset1_PD_GV,
} from '../sql/rulesets/new/ruleset1_PD_GV';
import {
    buildQuery_ruleset1_PD_QCV,
    order_ruleset1_PD_QCV,
    selectFields_ruleset1_PD_QCV
} from '../sql/rulesets/new/ruleset1_PD_QCV';
import {
    buildQuery_ruleset5_PD_6W,
    order_ruleset5_PD_6W,
    selectFields_ruleset5_PD_6W
} from '../sql/rulesets/new/ruleset5_PD_6W';
import {
    buildQuery_ruleset3_PI_EV_EPIV, order_ruleset3_PI_EV_EPIV,
    selectFields_ruleset3_PI_EV_EPIV
} from '../sql/rulesets/new/ruleset3_PI_EV_EPIV';
import {
    buildQuery_ruleset4_PIQCV,
    order_ruleset4_PIQCV,
    selectFields_ruleset4_PIQCV
} from '../sql/rulesets/new/ruleset4_PIQCV';
import {
    buildQuery_ruleset100_PIFLV,
    order_ruleset100_PIFLV,
    selectFields_ruleset100_PIFLV
} from '../sql/rulesets/new/ruleset100_PIFLV';
import {
    buildQuery_Ruleset6_PI_6W_EPIV, order_Ruleset6_PI_6W_EPIV,
    selectFields_Ruleset6_PI_6W_EPIV
} from '../sql/rulesets/new/ruleset6_PI_6W_EPIV';
import { buildQuery_AM_PD, order_AM_PD, selectFields_AM_PD } from '../sql/rulesets/new/AM_PD';
import { buildQuery_AM_PD_BFV, order_AM_PD_BFV, selectFields_AM_PD_BFV } from '../sql/rulesets/new/AM_PD_BFV';
import {
    buildQuery_AM_PD_BFV_OC,
    order_AM_PD_BFV_OC,
    selectFields_AM_PD_BFV_OC
} from '../sql/rulesets/new/AM_PD_BFV_OC';
import { buildQuery_AM_PD_QCV, order_AM_PD_QCV, selectFields_AM_PD_QCV } from '../sql/rulesets/new/AM_PD_QCV';
import {
    buildQuery_AM_PD_6W_CCV,
    order_AM_PD_6W_CCV,
    selectFields_AM_PD_6W_CCV
} from '../sql/rulesets/new/AM_PD_6W_CCV';
import { buildQuery_AM_PI, order_AM_PI, selectFields_AM_PI } from '../sql/rulesets/new/AM_PI';
import { buildQuery_AM_PI_6W, order_AM_PI_6W, selectFields_AM_PI_6W } from '../sql/rulesets/new/AM_PI_6W';
import {
    buildQuery_ruleset1_PD_OCCO,
    order_ruleset1_PD_OCCO,
    selectFields_ruleset1_PD_OCCO
} from '../sql/rulesets/new/ruleset1_PD_OCCO';

export const mapRulesetToQuery = (ruleset: RulesetEnum): {
    buildQuery: BuildRulesetQuery;
    selectFields: string;
    order: string;
} => {
    switch (ruleset) {
        case RulesetEnum.Ruleset1_PD:
            return {
                buildQuery: buildQuery_ruleset1_PD,
                selectFields: selectFields_ruleset1_PD,
                order: order_ruleset1_PD,
            }
        case RulesetEnum.Ruleset1_PD_GV:
            return {
                buildQuery: buildQuery_ruleset1_PD,
                selectFields: selectFields_ruleset1_PD,
                order: order_ruleset1_PD_GV,
            }
        case RulesetEnum.Ruleset1_PD_GV_3W_CO:
            return {
                buildQuery: buildQuery_ruleset1_PD_OCCO,
                selectFields: selectFields_ruleset1_PD_OCCO,
                order: 'DN, PN, label',
            }
        case RulesetEnum.Ruleset1_PD_OCCO:
            return {
                buildQuery: buildQuery_ruleset1_PD_OCCO,
                selectFields: selectFields_ruleset1_PD_OCCO,
                order: order_ruleset1_PD_OCCO,
            }
        case RulesetEnum.Ruleset1_PD_QCV:
            return {
                buildQuery: buildQuery_ruleset1_PD_QCV,
                selectFields: selectFields_ruleset1_PD_QCV,
                order: order_ruleset1_PD_QCV,
            }
        case RulesetEnum.Ruleset5_PD_6W:
            return {
                buildQuery: buildQuery_ruleset5_PD_6W,
                selectFields: selectFields_ruleset5_PD_6W,
                order: order_ruleset5_PD_6W,
            }

        case RulesetEnum.Ruleset3_PI_EV_EPIV:
            return {
                buildQuery: buildQuery_ruleset3_PI_EV_EPIV,
                selectFields: selectFields_ruleset3_PI_EV_EPIV,
                order: order_ruleset3_PI_EV_EPIV,
            }

        case RulesetEnum.Ruleset4_PIQCV:
            return {
                buildQuery: buildQuery_ruleset4_PIQCV,
                selectFields: selectFields_ruleset4_PIQCV,
                order: order_ruleset4_PIQCV,
            }
        case RulesetEnum.Ruleset100_PIFLV:
            return {
                buildQuery: buildQuery_ruleset100_PIFLV,
                selectFields: selectFields_ruleset100_PIFLV,
                order: order_ruleset100_PIFLV,
            }
        case RulesetEnum.Ruleset6_PI_6W_QCV:
        case RulesetEnum.Ruleset6_PI_6W_EPIV:
            return {
                buildQuery: buildQuery_Ruleset6_PI_6W_EPIV,
                selectFields: selectFields_Ruleset6_PI_6W_EPIV,
                order: order_Ruleset6_PI_6W_EPIV,
            }
        case RulesetEnum.AM_PD:
            return {
                buildQuery: buildQuery_AM_PD,
                selectFields: selectFields_AM_PD,
                order: order_AM_PD,
            }
        case RulesetEnum.AM_PD_BFV:
            return {
                buildQuery: buildQuery_AM_PD_BFV,
                selectFields: selectFields_AM_PD_BFV,
                order: order_AM_PD_BFV,
            }
        case RulesetEnum.AM_PD_BFV_OC:
            return {
                buildQuery: buildQuery_AM_PD_BFV_OC,
                selectFields: selectFields_AM_PD_BFV_OC,
                order: order_AM_PD_BFV_OC,
            }
        case RulesetEnum.AM_PD_QCV:
            return {
                buildQuery: buildQuery_AM_PD_QCV,
                selectFields: selectFields_AM_PD_QCV,
                order: order_AM_PD_QCV,
            }
        case RulesetEnum.AM_PD_6W_CCV:
            return {
                buildQuery: buildQuery_AM_PD_6W_CCV,
                selectFields: selectFields_AM_PD_6W_CCV,
                order: order_AM_PD_6W_CCV,
            }
        case RulesetEnum.AM_PI:
            return {
                buildQuery: buildQuery_AM_PI,
                selectFields: selectFields_AM_PI,
                order: order_AM_PI,
            }
        case RulesetEnum.AM_PI_6W:
            return {
                buildQuery: buildQuery_AM_PI_6W,
                selectFields: selectFields_AM_PI_6W,
                order: order_AM_PI_6W,
            }
        default:
            throw new Error('not implemented');
    }
}
